export default __webpack_public_path__ + "static/media/mk.ac6054fd.svg";